const STORAGE_KEY = 'cardware_tokens';
const TOKEN_BUFFER_MS = 60000;

class AuthManager {
	setTokens(tokens) {
		if (!tokens?.idToken || !tokens?.refreshToken) return false;

		try {
			const decoded = this.decodeToken(tokens.idToken);
			const tokenData = {
				idToken: tokens.idToken,
				accessToken: tokens.accessToken,
				refreshToken: tokens.refreshToken,
				expiresAt: decoded.exp * 1000
			};

			sessionStorage.setItem(STORAGE_KEY, JSON.stringify(tokenData));
			return true;
		} catch (error) {
			return false;
		}
	}

	getIdToken() {
		try {
			const tokenData = this.getTokenData();
			if (!tokenData?.idToken) return null;
			if (this.isTokenExpired(tokenData.expiresAt)) return null;
			return tokenData.idToken;
		} catch {
			return null;
		}
	}

	getRefreshToken() {
		try {
			return this.getTokenData()?.refreshToken || null;
		} catch {
			return null;
		}
	}

	getTokenData() {
		try {
			const data = sessionStorage.getItem(STORAGE_KEY);
			return data ? JSON.parse(data) : null;
		} catch {
			return null;
		}
	}

	isTokenExpired(expiresAt) {
		if (!expiresAt) return true;
		return Date.now() >= (expiresAt - TOKEN_BUFFER_MS);
	}

	clearTokens() {
		try {
			sessionStorage.removeItem(STORAGE_KEY);
		} catch (error) {
			console.error('Failed to clear tokens:', error);
		}
	}

	decodeToken(token) {
		const base64Url = token.split('.')[1];
		const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
		const jsonPayload = decodeURIComponent(
			atob(base64)
				.split('')
				.map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
				.join('')
		);
		return JSON.parse(jsonPayload);
	}

	hasValidTokens() {
		const tokenData = this.getTokenData();
		if (!tokenData?.idToken) return false;
		return !this.isTokenExpired(tokenData.expiresAt);
	}
}

export const authManager = new AuthManager();
export default authManager;
